export const ThumbIcon = ({
  height = 30,
  width = 36,
  filled = false,
  isDislikeButton = false,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 94"
      fill={filled ? "#fff" : "none"}
      style={isDislikeButton ? { transform: "rotate(180deg)" } : {}}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 39.0633V88.5421C4 89.3512 4.65865 90.0039 5.46779 90L80.0693 89.484C84.369 89.4547 88.1802 86.7031 89.5464 82.6245C92.5563 73.6425 96.985 56.6832 95.8046 37.2419C95.6287 34.3573 93.3283 32.0571 90.4396 31.9281L62.2779 30.6676L62.6492 18.7562C62.7411 15.8424 61.8792 12.9695 60.1436 10.6263C58.4081 8.28314 55.9279 5.64289 52.834 4.32961C50.8326 3.47949 48.5146 4.32765 47.5081 6.25459L31.161 37.5839H5.48148C4.66256 37.5839 4 38.2464 4 39.0652V39.0633Z"
        stroke="#fff"
        strokeWidth="7"
        strokeMiterlimit="10"
      />
      <path d="M31 37V90" stroke="#fff" strokeWidth="7" strokeMiterlimit="10" />
    </svg>
  );
};
